import { Package, Truck } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const partsNav: NavEntry[] = [
  { label: 'Parts', icon: Package, path: '/parts', permission: 'parts:read', order: 20 },
  { label: 'Vendors', icon: Truck, path: '/vendors', permission: 'vendors:read', order: 21 },
]
